import * as Router from "react-router-dom";

/**
 * Текущий путь страницы для меню (правка №52). [Claude] 2026-11-03
 * Во многих тестах страниц react-router-dom подменён заглушкой без useLocation —
 * тогда берём window.location, чтобы меню не роняло чужие тесты.
 */
const useRouterLocation = typeof Router.useLocation === "function" ? Router.useLocation : null;

export function useMenuPathname() {
    const loc = useRouterLocation ? useRouterLocation() : null; // eslint-disable-line react-hooks/rules-of-hooks
    if (loc && typeof loc.pathname === "string") return loc.pathname;
    return typeof window !== "undefined" ? window.location.pathname : "/";
}
